// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"97ab8439","225":"2e21e7bd","270":"2d629379","459":"e1c3037f","510":"665a51c1","660":"a6055929","674":"19d8099c","745":"ab82b03a","784":"7e916969","929":"2693301c","962":"d1774d92"}[chunkId] + ".chunk.js";
};